import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function DatabaseConnectionFields({ dbType, config, mode, onModeChange, onChange, disabled }) {
  const mongo = dbType === "mongodb";
  return (
    <div className="grid grid-cols-2 gap-3 border border-[#E2E8F0] rounded-xl p-3">
      {mongo && (
        <div className="col-span-2">
          <Label className="text-xs text-slate-600">Cara Koneksi</Label>
          <Select value={mode} onValueChange={onModeChange} disabled={disabled}>
            <SelectTrigger className="bg-[#F1F5F9] border-[#E2E8F0] mt-1" data-testid="mongo-connection-mode"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-[#FFFFFF] border-[#E2E8F0] text-slate-900">
              <SelectItem value="fields">Host &amp; Port</SelectItem>
              <SelectItem value="uri">Connection URI (lanjutan)</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
      {mongo && mode === "uri" ? (
        <div className="col-span-2">
          <Label className="text-xs text-slate-600">Connection URI</Label>
          <Input type="password" autoComplete="new-password" value={config.uri} disabled={disabled} onChange={(e) => onChange("uri", e.target.value)} data-testid="db-uri-input" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1 font-mono-code text-xs" placeholder={config.has_uri ? "Tersimpan; kosongkan untuk tetap memakai URI lama" : "mongodb://... atau mongodb+srv://..."} />
        </div>
      ) : (
        <>
          <div>
            <Label className="text-xs text-slate-600">Host</Label>
            <Input value={config.host} disabled={disabled} onChange={(e) => onChange("host", e.target.value)} data-testid="db-host-input" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1" placeholder={mongo ? "IP VPS, domain, atau host tunnel" : "Host database"} />
          </div>
          <div>
            <Label className="text-xs text-slate-600">Port</Label>
            <Input value={config.port} disabled={disabled} onChange={(e) => onChange("port", e.target.value)} data-testid="db-port-input" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1" placeholder={mongo ? "27017" : dbType === "postgresql" ? "5432" : "3306"} inputMode="numeric" />
          </div>
        </>
      )}
      <div className="col-span-2">
        <Label className="text-xs text-slate-600">Nama Database</Label>
        <Input value={config.database} disabled={disabled} onChange={(e) => onChange("database", e.target.value)} data-testid="db-name-input" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1" />
      </div>
      {(!mongo || mode === "fields") && (
        <>
          <div>
            <Label className="text-xs text-slate-600">Username</Label>
            <Input value={config.username} disabled={disabled} onChange={(e) => onChange("username", e.target.value)} data-testid="db-username-input" autoComplete="off" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1" placeholder={mongo ? "Opsional jika tanpa autentikasi" : "Username database"} />
          </div>
          <div>
            <Label className="text-xs text-slate-600">Password</Label>
            <Input type="password" value={config.password} disabled={disabled} onChange={(e) => onChange("password", e.target.value)} data-testid="db-password-input" autoComplete="new-password" className="bg-[#F1F5F9] border-[#E2E8F0] mt-1" placeholder={config.has_password ? "Tersimpan; kosongkan untuk mempertahankan" : mongo ? "Isi jika akun memakai password" : "Password database"} />
          </div>
        </>
      )}
      {mongo && (
        <p className="col-span-2 text-[11px] text-slate-500">
          Gunakan IP/domain VPS yang dapat diakses backend, atau host dan port lokal tunnel yang aktif.
          {mode === "fields" && " Autentikasi memakai database admin. Untuk authSource lain atau opsi TLS/replica set, pilih Connection URI."}
        </p>
      )}
    </div>
  );
}
